import holidayService from '../../../common/service/holidayService';

const GET_LISTING_PACKAGES_URL = '/listing/packages/v2';

export const getListingPackages = async params => {
  const response = await holidayService.post(GET_LISTING_PACKAGES_URL, params);

  return response;
};
